<mat-card [@slideDown]="!!summary ? 'visible' : 'hidden'" class="card-margin summary-content">
  <h2>{{ 'orders.results' | transloco }}</h2>
  <div class="flex-container">
    <div class="flex-item">
      <div class="flex-container">
        <div class="flex-item">{{ 'orders.fileCurrency' | transloco }}</div>
        <div class="flex-item">{{ $safeNavigationMigration(summary?.fileCurrency) | date: 'yyyy-MM-dd' }}</div>
      </div>
      <div class="flex-container">
        <div class="flex-item">{{ 'orders.totalResults' | transloco }}</div>
        <div class="flex-item">{{ summary?.total }}</div>
      </div>
      @if((summary?.totalExact ?? -1) > -1 || (summary?.totalSimilar ?? -1) > -1) {
        <div class="flex-container">
          <div class="flex-item">{{ 'orders.totalExactResults' | transloco }}</div>
          <div class="flex-item">{{ summary?.totalExact }}</div>
        </div>
        <div class="flex-container">
          <div class="flex-item">{{ 'orders.totalSimilarResults' | transloco }}</div>
          <div class="flex-item">{{ summary?.totalSimilar }}</div>
        </div>
      }
      @if((summary?.totalChanges ?? -1) > -1) {
        <div class="flex-container">
          <div class="flex-item">{{ 'orders.totalChangeResults' | transloco }}</div>
          <div class="flex-item">{{ summary?.totalChanges }}</div>
        </div>
      }
      @if((summary?.totalUnparsed ?? -1) > -1) {
        <div class="flex-container">
          <div class="flex-item">{{ 'orders.totalUnparsedResults' | transloco }}</div>
          <div class="flex-item">{{ summary?.totalUnparsed }}</div>
        </div>
      }
    </div>
    <div class="flex-item">
      @if(summary?.isStolenVehicleCheckClear === true) {
        <div class="flex-container">
          <div class="flex-item">{{ 'orders.stolenVehicleCheck' | transloco }}</div>
          <div class="flex-item">{{ 'common.buttons.clear' | transloco }}</div>
        </div>
      } @else if($safeNavigationMigration(summary?.reportedStolenIn) !== null &&
        summary!.reportedStolenIn!.length > 0) {
        <div class="flex-container">
          <div class="flex-item">{{ 'orders.stolenVehicleCheck' | transloco }}</div>
          <div class="flex-item">{{ 'orders.reportedStolenIn' | transloco: { jurisdictions: combineStolenJurisdictions() } }}</div>
        </div>
      } @else if(summary?.isStolenVehicleCheckClear === false) {
        <div class="flex-container">
          <div class="flex-item">{{ 'orders.stolenVehicleCheck' | transloco }}</div>
          <div class="flex-item">{{ 'orders.detectedReportedStolen' | transloco }}</div>
        </div>
      }
      @if(summary?.make) {
        <div class="flex-container">
          <div class="flex-item">{{ 'orders.make' | transloco }}</div>
          <div class="flex-item">{{ summary?.make }}</div>
        </div>
      }
      @if(summary?.model) {
        <div class="flex-container">
          <div class="flex-item">{{ 'orders.model' | transloco }}</div>
          <div class="flex-item">{{ summary?.model }}</div>
        </div>
      }
      @if(summary?.year) {
        <div class="flex-container">
          <div class="flex-item">{{ 'orders.year' | transloco }}</div>
          <div class="flex-item">{{ summary?.year }}</div>
        </div>
      }
      @if(summary?.trim) {
        <div class="flex-container">
          <div class="flex-item">{{ 'orders.trim' | transloco }}</div>
          <div class="flex-item">{{ summary?.trim }}</div>
        </div>
      }
    </div>
  </div>
</mat-card>
<div [@slideDown]="(summary?.ppsaSummaryResults?.length ?? 0) > 0 ? 'visible' : 'hidden'">
  <mat-card class="card-margin heading padding-right-15">
    <mat-card-content>
      <div class="heading-content flex-container">
        <span class="flex-item-2 bold">
          {{ 'common.labels.number' | transloco }}
        </span>
        <span class="flex-item bold">
          {{ 'orders.remaining2' | transloco }}
        </span>
        <span class="flex-item-2 bold">
          {{ 'orders.debtor' | transloco }}
        </span>
        <span class="flex-item-2 bold">
          {{ 'orders.securedParty' | transloco }}
        </span>
        <span class="flex-item bold">
          {{ 'common.labels.type' | transloco }}
        </span>
      </div>
    </mat-card-content>
  </mat-card>
  @for (result of summary?.ppsaSummaryResults ?? []; track result.id) {
    <div style="padding-bottom: 16px" role="button" tabindex="0"
      [attr.aria-label]="'orders.openResult' | transloco: { ref: (order?.jurisdiction === 'ON' ? result.fileNumber : (result.registrationNumber ?? result.baseRegistrationNumber)) }"
      (click)="open(result)" (keydown.enter)="open(result)" (keydown.space)="$event.preventDefault(); open(result)"
      (focus)="onResultMouseEnter(result)" (blur)="onResultMouseLeave(result)"
      (mouseenter)="onResultMouseEnter(result)"
      (mouseleave)="onResultMouseLeave(result)">
      <mat-card [ngClass]="{ 'highlight': shouldHighlightResult(result), 'highlight-dark': hoveredResult === result }"
        class="card-margin padding-right-15">
        <mat-card-content class="pointer">
          <div class="summary-content flex-container">
            <div class="flex-item-2 overflow-ellipsis">{{ order?.jurisdiction === 'ON' ? result.fileNumber :
              result.registrationNumber ?? result.baseRegistrationNumber }}
            </div>
            <div class="flex-item">
              @if(result.isDischarged) {
                <span>{{ 'orders.discharged' | transloco }}</span>
              } @else if(result.from && result.to) {
                <span>
                  {{ getRemainingRegistrationPeriod(result) }}
                </span>
              } @else if(result.isInfiniteTerm) {
                <div style="padding-left: 25px">
                  <span><mat-icon>all_inclusive</mat-icon></span>
                </div>
              }
            </div>
            <div class="flex-item-2 overflow-ellipsis">
              {{ getFirstDebtorName(result) }}
            </div>
            <div class="flex-item-2 overflow-ellipsis">
              {{ getFirstSecuredPartyName(result) }}
            </div>
            @if(order?.jurisdiction === 'ON') {
              <div class="flex-item">
                <span>{{ result.changeType ?? result.registrationType }}</span>
              </div>
            } @else {
              <div class="flex-item">
                <span>{{ result.resultType }}</span>
              </div>
            }
          </div>
        </mat-card-content>
        @if (shouldShowRegistrationExpiryValue(result)) {
          <mat-card-footer>
            <mat-progress-bar class="example-margin padding-right-15" [mode]="result.isInfiniteTerm ? 'buffer' : 'determinate'"
              [bufferValue]="100" [value]="getExpiryRegistrationValue(result)">
            </mat-progress-bar>
          </mat-card-footer>
        }
      </mat-card>
    </div>
  }
</div>